import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dll",
  "use": "icon-dll-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dll\"><path fill=\"#333333\" d=\"M988.16 67.584l-436.224 58.368v346.112h436.224V67.584z m-516.096 67.584L35.84 194.56v278.528h436.224v-337.92zM37.888 550.912V829.44l436.224 58.368V552.96l-436.224-2.048z m514.048 0v346.112l436.224 58.368V550.912H551.936z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol